import React from 'react'
import t from '../../../../../../../translations/main'
import utils from 'src/components/Organisms/Form/utils'
import Font from 'src/components/Core/Typography/Font/Font'
import { Trans } from 'react-i18next'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'
import { ConfigCompanyDetails } from '../../../../CorporateAccount/CompanyDetails/types'

const PleaseFillText = (
  <Font
    key='pleaseFillText'
    ellipsis={false}
  >
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.modal.visualOnly.pleaseFill'} />
  </Font>
)

const IfTINavailableText = (
  <Font
    key='IfTINavailableText'
    ellipsis={false}
  >
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.TaxResidencyForm.modal.visualOnly.ifTINavailable'} />
  </Font>
)

const config = ({ countries }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'TaxResidencyForm',
  path: 'onboarding.forms.CorporateAccount.TaxResidencyForm.modal.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        rowGap: '16px'
      },
      content: [
        {
          componentType: '',
          visualComponent: PleaseFillText
        },
        {
          componentType: 'input',
          props: {
            name: 'country',
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'country',
            label: 'onboarding.forms.CorporateAccount.TaxResidencyForm.modal.inputs.country.label',
            placeholder: 'onboarding.forms.CorporateAccount.TaxResidencyForm.modal.inputs.country.placeholder',
            bgTransparent: true,
            filter: true,
            ...props
          })
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'isTINAvailable',
            dataList: [
              {
                id: 'isTINAvailable1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'isTINAvailable2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        padding: '0 0 0 4%',
        boxSizing: 'border-box',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'tin',
            minHeight: '0',
            required: true,
            maxlength: 100,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        padding: '0 0 0 4%',
        boxSizing: 'border-box',
      },
      content: [
        {
          componentType: '',
          visualComponent: IfTINavailableText,
          visualName: 'ifTINavailableText',
        },
        {
          componentType: 'dropdown',
          props: {
            name: 'reason',
            minHeight: '0',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'reasonForNotObtainTIN',
            isTextarea: true,
            required: true,
            textAreaHeight: '90px',
            textAreaPointerEvents: 'auto',
            maxlength: 100,
          },
        },
      ],
    }
  ],
})

export default config
